<div class="modal fade" id="congrts">
    <div class="modal-dialog modal-dialog-sm modal-dialog-center">
        <div class="modal-content">
            <div class="modal-body !pt-4 !px-4 !pb-6 md:!py-12 md:!px-12">
                <button type="button" title="Close" aria-label="Close" data-modal-dismiss="Close"
                    class="absolute md:w-auto -top-2 -right-2 md:right-[18px] md:top-[18px]">
                </button>
                <div class="text-center">
                    <img src="/assets/images/icons/success.svg" alt="succcess icon" width="64" height="64"
                        class="w-[64px] h-[64px] block mx-auto mb-6">
                    <p class="text-20 mb-4 font-inter-semibold">Success</p>
                    <p class="text-16 mb-0 text-[#666868]">{{toastMsg || 'Form submitted successfully'}}</p>
                    <button class="button button-orange button-full mt-8" title="Done" id='close'
                        data-modal-dismiss="Close" type="button">Done</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- “ Thank you for your Interest. Our Wealth Executive will get in touch with you as per your Preferred time “ -->